/**
 * BlueprintBackdrop — faded architectural grid + isometric line accent.
 * Pure CSS / SVG; no external assets. Inspired by plangenerator.com.au.
 *
 * Variants:
 *  - "hero"   → soft offset radial mask (top-right focal point)
 *  - "dense"  → centered, stronger grid (login/register split-screen)
 *  - "panel"  → large centered grid for full-bleed sections
 */
const BlueprintBackdrop = ({ variant = "hero", showIsometric = true }) => {
  const gridClass = variant === "dense" ? "blueprint-grid-dense" : "blueprint-grid";

  return (
    <>
      {/* Faded grid */}
      <div className={gridClass} aria-hidden="true" />

      {/* Isometric line-art building accent — corner decoration */}
      {showIsometric && (
        <svg
          aria-hidden="true"
          className="blueprint-iso pointer-events-none absolute right-[-60px] bottom-[-40px] w-[520px] h-[420px] hidden md:block"
          viewBox="0 0 520 420"
          fill="none"
          stroke="currentColor"
          strokeWidth="1.2"
          style={{ color: "rgba(14,27,44,0.10)" }}
        >
          {/* Isometric house outline */}
          <path d="M260 60 L420 140 L420 320 L260 400 L100 320 L100 140 Z" />
          <path d="M260 60 L260 240 M100 140 L260 240 M260 240 L420 140" />
          {/* Floor lines */}
          <path d="M100 200 L260 280 L420 200" opacity="0.7" />
          <path d="M100 260 L260 340 L420 260" opacity="0.5" />
          {/* Door + windows */}
          <path d="M195 230 L195 305 L235 325 L235 250 Z" opacity="0.7" />
          <path d="M285 250 L325 230 L325 270 L285 290 Z" opacity="0.6" />
          <path d="M345 220 L385 200 L385 240 L345 260 Z" opacity="0.5" />
          {/* Subtle dimension marks */}
          <path d="M40 320 L80 340" opacity="0.4" />
          <path d="M40 320 L40 360 M80 340 L80 380" opacity="0.4" />
          {/* Floating draft circles */}
          <circle cx="460" cy="80" r="28" opacity="0.4" />
          <circle cx="460" cy="80" r="14" opacity="0.4" />
        </svg>
      )}
    </>
  );
};

export default BlueprintBackdrop;
